import { render } from "./dl-image.vue?vue&type=template&id=51d8796a"
import script from "./dl-image.vue?vue&type=script&lang=js"
export * from "./dl-image.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/doctolib-hos-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__